import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ClientProfileService, UserService} from "../../_services";
import {WorkstreamService} from "../../_services/workstream.service";

@Component({
    standalone: false,
  selector: "workstream",
  templateUrl: 'workstream.component.html',
  styleUrls: ['./workstream.component.scss'],
})

export class WorkstreamComponent implements OnInit {
  users: any;
  workstream: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public userService: UserService,
              public workstreamService: WorkstreamService,
              public dialogRef: MatDialogRef<WorkstreamComponent>)
  {
    this.workstream = data.entity;
    console.log(this.workstream)
  }
  ngOnInit(): void {
  }

  save(): void {
    this.workstreamService.saveWorkstream(this.workstream).subscribe(r => this.close());
  }

  close(): void {
    this.dialogRef.close();
  }
}
